export const formatDataForCampaign = data => ({
    ...data,
    budget: {
        currency: 'BRL',
        amount: data.budget,
    },
    location: data.location.value,
    name: data.campaignName,
});

export const formatDraftCampaign = (data, initialData) => {
    if (data.length === 0) {
        return initialData;
    }
    const draftCampaign = data[0];
    return {
        ...draftCampaign,
        campaignName: draftCampaign.name,
        budget: draftCampaign.budget.amount,
        startDate: new Date(draftCampaign.startDate),
        endDate: new Date(draftCampaign.endDate),
        // Location is fixed for now
        location: {
            value: draftCampaign.location,
            label: 'Rio de Janeiro',
        },
    };
};

export const formatCampaign = data => ({
    ...data,
    campaignName: data.name,
    budget: data.budget.amount,
    startDate: new Date(data.startDate),
    endDate: new Date(data.endDate),
    // Location is fixed for now
    location: {
        value: data.location,
        label: 'Rio de Janeiro',
    },
});
